<section class="px-[120px] py-12">
  <div class="flex items-center justify-between gap-4 pb-6">
    <div class="flex items-center gap-4 w-full">
      <div class="flex gap-4 w-[55%]">
        <glo-control
          icon="search"
          placeholder="Service or business"
          class="w-1/2"
          classes="bg-gray-50"
        ></glo-control>
        <glo-control
          icon="marker-lg"
          placeholder="Sapinero, Colorado, USA"
          class="w-1/2"
          classes="bg-gray-50"
        ></glo-control>
      </div>
      <glo-control
        icon="calendar"
        type="calendar"
        placeholder="Wed, 11 Mar"
        classes="bg-gray-50"
      ></glo-control>
      <glo-control
        icon="clock"
        placeholder="09.00 - 12.00"
        classes="bg-gray-50"
      ></glo-control>
      <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">
        Discover Now
      </button>
    </div>
  </div>

  <glo-tabs [tabs]="tabs" class="border-b border-gray-200 pb-4">
    <ng-template gloTabContent="near-me">
      <div class="flex flex-col pt-2 pb-4 gap-2">
        <h2 class="text-3xl text-gray-900 pb-2">Near me</h2>
        <p class="text-md text-gray-600">
          Discover top salons, must-try treatments, and the best beauty deals
          near you.
        </p>
      </div>

      <div class="flex flex-col">
        <div class="grid grid-cols-4 gap-6">
          <ng-container
            *ngFor="
              let salon of salons.slice(
                (currentPage - 1) * pageSize,
                currentPage * pageSize
              )
            "
          >
            <a
              [routerLink]="['/customer/salon']"
              class="p-3 rounded-xl border shadow overflow-hidden relative bg-white hover:shadow-lg transition card-scale"
            >
              <div class="relative mb-4">
                <div class="rounded-lg bg-cover bg-center h-40 overflow-hidden">
                  <div
                    class="card-img w-full h-full"
                    [ngStyle]="{
                      'background-image': 'url(' + salon.image + ')',
                    }"
                  ></div>
                </div>
                <span
                  *ngIf="salon.isPopular"
                  class="absolute top-3 left-[-6px] px-2 py-1 text-xs text-purple bg-light-purple rounded-tl rounded-tr-[99px] rounded-br-[99px] rounded-bl"
                >
                  Popular
                </span>
                <button class="absolute top-0 right-0 m-2">
                  <img [src]="assetUrl + 'icons/favorite.svg'" alt="fav icon" />
                </button>
              </div>
              <h4 class="pb-3 text-md font-semibold">{{ salon.name }}</h4>
              <div class="flex items-center text-sm">
                <img [src]="assetUrl + 'icons/star.svg'" class="mr-1 w-4 h-4" />
                <span>{{ salon.rating }} • {{ salon.reviews }} Reviews</span>
              </div>
              <div class="flex items-center text-gray-600 text-sm pt-1">
                <img
                  [src]="assetUrl + 'icons/marker.svg'"
                  class="mr-1 w-4 h-4"
                />
                <span>{{ salon.distance }} • {{ salon.location }}</span>
              </div>
              <div class="flex flex-wrap text-gray-600 text-sm pt-3">
                <glo-tag
                  *ngFor="let tag of salon.tags"
                  [text]="tag"
                  state="default"
                  class="mr-2 mb-1"
                  [showIcon]="false"
                ></glo-tag>
              </div>
            </a>
          </ng-container>
        </div>
        <glo-pagination
          *ngIf="salons.length > 0"
          [totalItems]="salons.length"
          [(currentPage)]="currentPage"
          [(itemsPerPage)]="pageSize"
          [itemsPerPageOptions]="[4, 8, 12, 16]"
          (currentPageChange)="onPageChange($event)"
        >
        </glo-pagination>
      </div>
    </ng-template>
  </glo-tabs>
</section>
